



















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'PlatformNoticeDialog'
})
export default class PlatformNoticeDialog extends Vue {
  @Prop({ default: false }) readonly visible!: boolean;
  @Prop({ default: '' }) readonly message!: string;

  public handleConfirm() {
    this.$emit('update:visible', false);
  }
}
